import React from 'react';
import styles from './ModuleWrap.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const ModuleWrap = (props) => {
    return (
        <div className={styles.divWrapper}>
            <div className={styles.headerBar}>
                <FontAwesomeIcon className={styles.icon} icon={props.icon}/>
                {props.title}
            </div>
            <div className={styles.text}>
                {props.children}
            </div>
        </div>
    )
};

export default ModuleWrap;


// WEBPACK FOOTER //
// ./src/components/ModuleWrap/ModuleWrap.js